export default "__VITE_ASSET__C$FRELJg__"